(function (Drupal, once) {

  let currentRoot;
  const bodyClass = 'vliz-mobile-nav-active';
  const toggleChild = function(item) {
    if (item.classList.contains('menu-active')) {
      item.classList.remove('menu-active');
    } else {
      item.classList.add('menu-active');
    }
  }

  Drupal.behaviors.vlizMobilenav = {
    attach(context, settings) {
      const hamburgers = once('hamburger-toggle', 'button.hamburger');
      const menusItems = once('expanded-menu-items', '.region-mobile-overlay li.menu-item--expanded');

      hamburgers.forEach(hamburgerToggle => {
        hamburgerToggle.addEventListener('click', (e) => {
          e.preventDefault();

          let overlay = document.querySelector('.region-mobile-overlay');
          let headerHeight = document.querySelector('header').offsetHeight;

          overlay.style.setProperty('--overlay-header-height', headerHeight + 'px');

          if (overlay) {
            hamburgerToggle.classList.toggle('is-active');
            overlay.classList.toggle('is-active');

            if (document.body.classList.contains(bodyClass)) {
              setTimeout(() => {
                document.body.classList.remove(bodyClass);
              }, 100);
            } else {
              document.body.classList.add(bodyClass);
            }

          }
        });
      });

      menusItems.forEach(menuItem => {
        const childMenu = menuItem.querySelector(':scope > ul.menu');
        const toggleItem = menuItem.querySelector(':scope > span');

        if (childMenu && toggleItem) {
          toggleItem.addEventListener('click', (e) => {
            e.preventDefault();
            toggleChild(menuItem);
          });
        }
      });
    }
  }

}(Drupal, once));
